<template>
  <div class="tinymce-editor-container">
    <div :id="editorId"></div>
  </div>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
import { isEn } from '@/i18n'
import tinymce from 'tinymce'
import 'tinymce/plugins/image'
import 'tinymce/plugins/imagetools'
import 'tinymce/plugins/link'
import 'tinymce/plugins/media'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/advlist'
import { getFilePath, uploadFile } from '@/utils/qiniu'

export default {
  mixins: [emitter],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    const editorId = `instance_${new Date().valueOf()}_${parseInt(Math.random() * 1000 + 1)}`
    return {
      isEn,
      editorId,
      editor: null
    }
  },
  computed: {
  },
  created () {

  },
  mounted () {
    this.createEditor()
  },
  beforeDestroy () {
    this.editor = null
  },
  methods: {
    resetEditor () {
      this.editor = null
      this.$nextTick(() => {
        this.createEditor()
      })
    },
    async createEditor () {
      if (!this.editor) {
        const setting = {
          base_url: `${window.location.origin}/vue-static/tinymce`,
          suffix: '.min',
          target: this.$el.firstElementChild,
          noneditable_noneditable_class: 'mceNonEditable',
          min_height: 380,
          plugins: ['image', 'imagetools', 'link', 'media', 'table', 'lists', 'advlist', 'noneditable'],
          toolbar: [
            'undo redo pastetext forecolor backcolor bold italic underline strikethrough link alignleft aligncenter alignright alignjustify bullist numlist image removeformat',
            'formatselect fontselect fontsizeselect'
          ],
          branding: false,
          resize: true,
          toolbar_mode: 'wrap',
          convert_urls: false,
          relative_urls: false,
          content_css: [
          ],
          language: isEn() ? 'en' : 'zh_CN',
          menubar: false,
          images_upload_handler: this.imagesUploadHandler
        }

        const editors = await tinymce.init(setting)
        const editor = editors[0]
        this.editor = editor
        editor.on('change input undo redo', () => {
          const content = editor.getContent()
          this.$emit('change', content)
          this.dispatch('ElFormItem', 'el.form.change', [content])
        })
      }
      this.editor.setContent(this.value || '')
      this.editor.setMode(this.disabled ? 'readonly' : 'design')
    },
    async imagesUploadHandler (blobInfo, success, failure, progress) {
      const file = blobInfo.blob()
      const fileName = file.name
      const fileKey = `site-message/${fileName}`
      const resp = await uploadFile(file, fileKey)
      if (resp) {
        this.fileKey = resp.key
        const filePath = getFilePath(this.fileKey)
        success(filePath)
      }
    }
  },
  watch: {
    '$i18n.locale' () {
      if (this.editor) {
        this.editor.settings.language = isEn() ? 'en' : 'zh_CN'
        this.editor.render()
      }
    },
    value: {
      immediate: true,
      handler () {
        const value = this.value || ''
        if (this.editor) {
          const content = this.editor.getContent()
          if (content !== value) {
            this.editor.setContent(value)
            this.editor.setMode(this.disabled ? 'readonly' : 'design')
          }
        }
      }
    },
    editor (newVal, oldVal) {
      if (oldVal) {
        tinymce.remove(oldVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
